import { FilterTemplate } from "./FilterTemplate";
import { useTranslation } from "react-i18next";

interface RatingFilterProps {
	innerRef: React.RefObject<{
		getFilters: () => string[];
	}>;
	handleApply: () => void;
}

export const RatingFilter: React.FC<RatingFilterProps> = ({ innerRef, handleApply }) => {
	const { t } = useTranslation();

	const solutionTypes = [
		{ id: 100000000, name: t("QUICK_WIN") },
		{ id: 100000002, name: t("NICE_TO_HAVE") },
		{ id: 100000001, name: t("COMPLEX_PROJ") },
		{ id: 100000003, name: t("TO_AVOID") },
	];

	return <FilterTemplate innerRef={innerRef} records={solutionTypes} title="JS_78" icon="star" handleApply={handleApply} />;
};
